import React from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  Theme,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { v4 } from 'uuid';
import clsx from 'clsx';

import {
  FormatListNumbered as FormatListNumberedIcon,
} from '@material-ui/icons';

import styles from './ResultCard.styles';
import {
  RequestListResult,
  RequestOrderInfo,
} from '../types';
import ProgressMask from '../../../../components/progressMask';
import NetworkState from '../../../../core/types/network';

const useStyles = makeStyles(styles);

type Props = {
  requestLists?: RequestListResult;
  resultNetworkStates: {
    resultRequest: NetworkState;
  };
};

const ResultCard: React.FC<Props> = ({
  requestLists,
  resultNetworkStates: {
    resultRequest,
  },
}: Props) => {
  const classes = useStyles();

  const isMediumScreen = useMediaQuery((themeS: Theme) => themeS.breakpoints.up('sm'));
  const TestOrderCompact: React.FC<{ order: RequestOrderInfo[] }> = ({
    order,
  }: { order: RequestOrderInfo[] }) => (
    <Box className={classes.statusBox}>
      {order.map((list, index) => (
        <Typography
          key={v4()}
          className={clsx({
            [classes.orderCancelled]: list.status === 'cancelled',
            [classes.orderProcess]: list.status === 'process',
            [classes.orderNormal]: list.status === 'complete' && !list.flag,
            [classes.orderAbnormal]: list.status === 'complete' && list.flag,
          })}
          component="span"
          color="inherit"
          variant="h5"
          align="center"
        >
          {index === 0 ? list.name : `, ${list.name}`}
        </Typography>
      ))}
    </Box>
  );

  return (
    <Box className={classes.root}>
      {resultRequest.isRequesting && (
        <ProgressMask />
      )}
      {!resultRequest.isRequesting && requestLists && requestLists?.requestLists.map((val) => (
        <Paper classes={{ root: classes.resultPaper }} elevation={1} key={val.id}>
          <Box className={classes.resultBox}>
            <Grid item container style={{ height: '100%' }}>
              <Grid item container xs={12} sm={2} alignItems="center" justify="center" direction="column">
                <Typography variant="body1">
                  เลขที่ใบสั่งตรวจ
                </Typography>
                <Typography variant="h5">
                  {val.labNumber}
                </Typography>
              </Grid>
              <Grid item container xs={12} sm={2} alignItems="center" justify="center" direction="column">
                <Typography variant="body1">
                  วันที่ตรวจ
                </Typography>
                <Typography variant="h5">
                  {moment(val.date).format('DD/MM/YYYY')}
                </Typography>
              </Grid>
              <Grid item container xs={12} sm={8} alignItems="center" justify="center" direction="column">
                <Typography variant="body1">
                  รายการตรวจ
                </Typography>
                <Tooltip
                  title={val.testOrder?.map((test) => test.name).join(', ') || ''}
                >
                  <Box>
                    {TestOrderCompact({ order: val.testOrder || [] })}
                  </Box>
                </Tooltip>
              </Grid>
              <Grid item container xs={12} alignItems="flex-end" direction="column">
                <Button
                  color="secondary"
                  classes={{ root: classes.resultButton }}
                  variant="contained"
                  size="large"
                  fullWidth={!isMediumScreen}
                  onClick={() => {
                    const url = [
                      `id=${val.id}`,
                    ];
                    window.open(`resultDetails?${url.join('&')}`);
                  }}
                >
                  <FormatListNumberedIcon style={{ paddingRight: 8 }} />
                  ผลการตรวจ
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      ))}
    </Box>
  );
};

export default ResultCard;
